import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';
import { supabase } from '../lib/supabase';

interface AdminContextType {
  isAdmin: boolean;
  loading: boolean;
}

const AdminContext = createContext<AdminContextType>({ isAdmin: false, loading: true });

export function AdminProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const [state, setState] = useState<AdminContextType>({ isAdmin: false, loading: true });

  useEffect(() => {
    const checkAdmin = async () => {
      if (!user) {
        setState({ isAdmin: false, loading: false });
        return;
      }

      try {
        const { data, error } = await supabase
          .from('user_profiles')
          .select('role')
          .eq('user_id', user.id)
          .maybeSingle();

        if (error) {
          console.error('AdminContext - Erro ao verificar role:', error);
          setState({ isAdmin: false, loading: false });
        } else if (data) {
          const adminStatus = data.role === 'admin';
          console.log('AdminContext - Role encontrado:', data.role, 'isAdmin:', adminStatus);
          setState({ isAdmin: adminStatus, loading: false });
        } else {
          console.log('AdminContext - Perfil não encontrado para user_id:', user.id);
          setState({ isAdmin: false, loading: false });
        }
      } catch (error) {
        console.error('AdminContext - Erro ao verificar admin:', error);
        setState({ isAdmin: false, loading: false });
      }
    };

    checkAdmin();
  }, [user]);

  return <AdminContext.Provider value={state}>{children}</AdminContext.Provider>;
}

export function useAdminContext() {
  return useContext(AdminContext);
}

